
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/[deckId]/studyGuide",
      function () {
        return require("private-next-pages/app/[deckId]/studyGuide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/[deckId]/studyGuide"])
      });
    }
  